<template>
  <div>
    <!-- loading: {{this.loading}} store: {{this.$store.getters['loader/isLoading']}} -->
    <div style="position: fixed;" loading-status-message="" id="loading-container" v-show="loading">
      <div class="ajax-loader-container">
        <img class="ajax-loader" width="64" height="64" alt="" :src="`${appPath}/assets/images/757-loader.gif`" />
        <p class="ajax-loader-text">Please wait, do not close your browser or navigate away from this page.</p>
      </div>
    </div>

  </div>
</template>

<script>
import {
  loadingComputed,
  loadingMethods,
  loadingMutations
} from "@/state/helpers";
export default {
  name: "Loader",
  data() {
    return {
      key: "value",
      appPath: process.env.VUE_APP_VIR_DIR
    };
  },
  methods: {
    ...loadingMethods,
    ...loadingMutations,
    name() {}
  },
  computed: {
    ...loadingComputed
  }
};
</script>

<style scoped>
#loading-container {
  background: rgba(255, 255, 255, 0.8) none repeat scroll 0 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1090;
}
.ajax-loader-container {
  display: block;
  text-align: center;
}
.ajax-loader-container {
  background: #fff none repeat scroll 0 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  left: 50%;
  margin-left: -160px;
  margin-top: -114px;
  padding: 25px;
  position: absolute;
  top: 50%;
  width: 320px;
}
.ajax-loader-text {
  background: #ffffff none repeat scroll 0 0;
  padding-top: 25px;
  margin: 0 0 1.3em;
  text-align: center;
}
</style>